import './header.scss';

document.addEventListener( 'DOMContentLoaded', () => {
	const headerTop = document.querySelector( '.js-headerTop' );
	const body = document.body;

	const getHeaderHeight = () => {
		return headerTop ? headerTop.getBoundingClientRect().height : 0;
	};

	const bodyClassOnScroll = () => {
		const headerHeight = getHeaderHeight();
		if ( window.scrollY > headerHeight ) {
			body.classList.add( '-hasScrolled' );
		} else {
			body.classList.remove( '-hasScrolled' );
		}
	};

	window.addEventListener( 'scroll', bodyClassOnScroll, { passive: true } );
	bodyClassOnScroll();
} );